<script lang="ts" setup>
import { useI18n } from "vue-i18n";

const props = withDefaults(
  defineProps<{
    hazmatCommodity: boolean;
    size?: number | string;
    color?: string;
  }>(),
  {
    size: "small",
    color: "warning",
  },
);

const { t } = useI18n();
</script>

<template>
  <div v-if="props.hazmatCommodity">
    <v-tooltip location="top">
      <template #activator="{ props: tooltipProps }">
        <v-icon :color="props.color" :size="props.size" v-bind="tooltipProps">mdi-biohazard</v-icon>
      </template>
      {{ t("general.hazmat-commodity") }}
    </v-tooltip>
  </div>
</template>
